export default function getDimensions(): [number, number] {
    return [window.screen.width, window.screen.height];
}